import React from 'react';
import { css } from '@emotion/react';
import * as Tooltip from '@radix-ui/react-tooltip';
import { BirdiTheme } from '@birdi/theme'

interface Props {
  align?: 'start' | 'center' | 'end';
  side?: 'top' | 'right' | 'bottom' | 'left';
  children: {
    trigger: React.ReactNode;
    label: React.ReactNode;
  };
}

const TooltipButton: React.FC<Props> = ({ align, children, side }) => (
  <Tooltip.Provider delayDuration={500}>
    <Tooltip.Root>
      <Tooltip.Trigger asChild>{children.trigger}</Tooltip.Trigger>

      <Tooltip.Portal>
        <Tooltip.Content
          align={align}
          side={side}
          sideOffset={5}
          css={(theme: BirdiTheme) => css`
            background: ${theme.mono0};
            color: ${theme.mono98};
            padding: 4px 8px;
            line-height: 1.5em;
            border-radius: 4px;
            z-index: 9999;
          `}
        >
          {children.label}
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  </Tooltip.Provider>
);

export default TooltipButton;
